import React, { FC, useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"


import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import moment from "moment";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useLocation, useHistory } from "react-router-dom";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";

const WageData: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  

  const [stateList, setStateList] = useState([]);
  const [countyList, setCountyList] = useState([]);

  
  const [collab, setCollabs] = useState('');
  const [socCode, setSocCode] = useState('');
  const [socCodeTitle, setSocCodeTitle] = useState('');
  const [jobCodeTitle, setJobCode] = useState('');
  const [wageList, setWageListObj] = useState('');

  const [dolWageLevel1, setDolWageLevel1] = useState('');
  const [dolWageLevel2, setDolWageLevel2] = useState('');
  const [dolWageLevel3, setDolWageLevel3] = useState('');
  const [dolWageLevel4, setDolWageLevel4] = useState('');

  const [dolWageHourlyLevel1, setDolWageHourlyLevel1] = useState('');
  const [dolWageHourlyLevel2, setDolWageHourlyLevel2] = useState('');
  const [dolWageHourlyLevel3, setDolWageHourlyLevel3] = useState('');
  const [dolWageHourlyLevel4, setDolWageHourlyLevel4] = useState('');

  const [surveyWageLevel1, setsurveyWageLevel1] = useState('');
  const [surveyWageLevel2, setsurveyWageLevel2] = useState('');
  const [surveyWageLevel3, setsurveyWageLevel3] = useState('');
  const [surveyWageLevel4, setsurveyWageLevel4] = useState('');

  const [surveyWageHourlyLevel1, setsurveyWageHourlyLevel1] = useState('');
  const [surveyWageHourlyLevel2, setsurveyWageHourlyLevel2] = useState('');
  const [surveyWageHourlyLevel3, setsurveyWageHourlyLevel3] = useState('');
  const [surveyWageHourlyLevel4, setsurveyWageHourlyLevel4] = useState('');

  const red = "red";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const job_id = queryParams.get('job_id');

  const mydate = new Date();
  try {
    //const today = mydate.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  } catch (ex) {

  }

  // const jobtypeName = queryParams.get('name');


  function validateCheck() {
    if ($('#job_type').val() == '') {
      return false;
    }
    else if ($('#job_title').val() == '') {
      return false;
    }
    else {
      return true;
    }
  }


  const [query, setQuery] = useState("");
  let jobTitleGlobal = '';
   
  //get animated components wrapper
  const animatedComponents = makeAnimated();

 //var emaildefault = '';

 const {
     register,reset,
     formState: { errors },
     handleSubmit
   } = useForm({
     criteriaMode: "all",mode: "onBlur" 
   });


  
    
    // fetch filteres search results for dropdown
    //  const loadOptions = () => {
    //    return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`)
    //    .then((res) => res.json());
    //  };

     const loadOptions = () => {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', // Set the content type based on your API requirements
          },
          body: JSON.stringify({ title: query }), // Convert data to JSON format
        };
       
        return fetch('https://wagesurvey.hometownopportunity.com/api/jobSugList', requestOptions)
          .then((res) => res.json());
      };

     const getWageInfoCall = () => {
      var state = $("#stateId").val();
      var county = $("#countyId").val(); 
      var job_code = $("#jobCodeTitle").html();
      var soc_code    =$("#socCodeVal").html();
      

      //alert(socCodeTitle);      
     // alert(job_code);
      const requestObject = {
          "stateCode": state,      
          "county": county,      
          //"job_code": jobCode, 
          "job_code": job_code,           
          "soccode": soc_code,      

      }
      // console.log(JSON.stringify(objInputAvailableJobs));
      var accessTokenIn=sessionStorage.getItem("adminAccToken");
      const requestOptions = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              //'Authorization': "Bearer "+accessTokenIn 
              //'Authorization': accessTokenIn 
          },
          body: JSON.stringify(requestObject)
      };

      services.getSurveyWageList(requestOptions).then((res) => {
         console.log(JSON.stringify(res))
          if(res){
              setWageListObj(res);   
              setDolWageLevel1('');
              setDolWageLevel2('');
              setDolWageLevel3('');
              setDolWageLevel4('');

              setDolWageHourlyLevel1('');
              setDolWageHourlyLevel2('');
              setDolWageHourlyLevel3('');
              setDolWageHourlyLevel4('');

              setsurveyWageLevel1('');
              setsurveyWageLevel2('');
              setsurveyWageLevel3('');
              setsurveyWageLevel4('');

              setsurveyWageHourlyLevel1('');
              setsurveyWageHourlyLevel2('');
              setsurveyWageHourlyLevel3('');
              setsurveyWageHourlyLevel4('');
              try{
                  if ( typeof(res.dolWage[0].level1) != "undefined" && res.dolWage[0].level1 != null ) {    
                     // alert(res.dolWage[0].level1);
                      setDolWageLevel1(res.dolWage[0].level1);
                      setDolWageLevel2(res.dolWage[0].level2);
                      setDolWageLevel3(res.dolWage[0].level3);
                      setDolWageLevel4(res.dolWage[0].level4);
                  }
              }catch(ex){

              }
              
            
               try{
                  if ( typeof(res.dolWageHourly[0].level1) != "undefined" && res.dolWageHourly[0].level1 != null ) {     

                      setDolWageHourlyLevel1(res.dolWageHourly[0].level1);
                      setDolWageHourlyLevel2(res.dolWageHourly[0].level2);
                      setDolWageHourlyLevel3(res.dolWageHourly[0].level3);
                      setDolWageHourlyLevel4(res.dolWageHourly[0].level4);
                  }
              }catch(ex){
                  
              }
             
              

              try{
                  if ( typeof(res.surveyWage[0].level1) != "undefined" && res.surveyWage[0].level1 != null ) {     
                      setsurveyWageLevel1(res.surveyWage[0].level1);
                      setsurveyWageLevel2(res.surveyWage[0].level2);
                      setsurveyWageLevel3(res.surveyWage[0].level3);
                      setsurveyWageLevel4(res.surveyWage[0].level4);
                  }
              }catch(ex){
                  
              }
             
            

              try{
                  if ( typeof(res.surveyWageHourly[0].level1) != "undefined" && res.surveyWageHourly[0].level1 != null ) {         
                      setsurveyWageHourlyLevel1(res.surveyWageHourly[0].level1);
                      setsurveyWageHourlyLevel2(res.surveyWageHourly[0].level2);
                      setsurveyWageHourlyLevel3(res.surveyWageHourly[0].level3);
                      setsurveyWageHourlyLevel4(res.surveyWageHourly[0].level4);
                  }
              }catch(ex){
                  
              }
             
             
          }      
          
      });


      
   }   

   const getCountyByState = (stateId) => {

    const requestObject = {
        "stateCode": stateId      

    }
    // console.log(JSON.stringify(objInputAvailableJobs));
    var accessTokenIn=sessionStorage.getItem("adminAccToken");
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            //'Authorization': "Bearer "+accessTokenIn 
            //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
    };

    services.getCountyByStateFromWage(requestOptions).then((res) => {
       
        if(res){
            setCountyList(res);              
        }      
        
    });


    
 }


 const handleChange  = (selectedOption) => {
  //alert(JSON.stringify(selectedOption));
  var title = selectedOption.title;
  jobTitleGlobal = selectedOption.title;
  setJobCode(title);
  setSocCodeTitle(title);
  setSocCode(selectedOption.socCode);

}

const getStatesWage = () => {
   services.getStatesFromWage().then((res) => { 
       setStateList(res.data);        
   });
}
  const submitValue = () => {
    var industriesArray = [];






    const requestObject =
    {
      "jobId": "10"

    }
    console.log(requestObject);
    //return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

   
  }


function stateIdChange(){
  var st = $("#stateId").val()
  getCountyByState(st)
}


  useEffect(() => {
    //alert(job_id);
    $("#matchPwd").hide();
   // $('#phone').usPhoneFormat();
   ($('#phone_number') as any).usPhoneFormat();
   
   
   
    //getUserProfile();
    getStatesWage();
    
    /*
    $( "#stateId" ).change(function() {
        var st = $("#stateId").val()
        getCountyByState(st)
    });
    */

    setTimeout(() => {
        $("#stateId").val('OH')
        getCountyByState('OH')
    }, 1000)
        


    $( "#getWageInfo" ).click(function() {            
        getWageInfoCall()
    });

    

    $("#successMessage").hide();
    $("#imgError").hide();


  }, []);
  return (
    <>
      <PageTitle breadcrumbs={[]}>Wage Data</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          
        <main className="empr-directory-main">
                <div className="main-bgpatten"></div>
                {/* <!-- info typography --> */}
               
                {/* <!-- info typography --> */}
                <section className="py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 ">
                                <div className="white-bg p-5">
                                    <div className="row">
                                        {/* <!-- left side --> */}

                                        

                                        {/* <!-- right side --> */}
                                        <div className="col-lg-8 mb-4">
                                            <form onSubmit={handleSubmit(submitValue)} id="editCompanyUserForm">






                                                <div className="row resume-wrap">
                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor="firstName" className="form-label">State<span className="red-text">*</span></label>


                                                        <select className="form-select" id="stateId" onChange={stateIdChange}>
                                                            <option selected>List of States</option>
                                                            {
                                                                stateList.map((data, index) => (
                                                                    <option value={data.stateCode}>{data.stateName}</option>
                                                                ))}
                                                        </select>


                                                    </div>

                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor="firstName" className="form-label">County<span className="red-text">*</span></label>
                                                        <select className="form-select" id="countyId">
                                                            <option selected>List of Counties</option>
                                                            {
                                                                countyList.map((data, index) => (
                                                                    <option value={data.countyName}>{data.countyName}</option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor="firstName" className="form-label">Standardized job code<span className="red-text">*</span></label>
                                                        {/* <input type="text"  className="form-control" id="stjobcode"  defaultValue=""  {...register('stjobcode', { required: true, pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ })}/> */}


                                                        <AsyncSelect
                                                            cacheOptions
                                                            components={animatedComponents}
                                                            getOptionLabel={(e:any) => e.title}
                                                            getOptionValue={(e) => e.socCode}
                                                            loadOptions={loadOptions}
                                                            onInputChange={(value) => setQuery(value)}
                                                            onChange={handleChange}
                                                        // onChange={(value) => setSocCode(value)}
                                                        />
                                                    </div>

                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor="phone" className="form-label">Soc Code:</label>
                                                        <span id="socCodeVal">{socCode}</span>
                                                    </div>


                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor="phone" className="form-label">Job Title:</label>
                                                        <span id="jobCodeTitle">{jobCodeTitle}</span>
                                                    </div>


                                                    <div className="col-lg-12 mb-4">
                                                        <button type="button" id="getWageInfo" className="reg-button">Search</button>
                                                    </div>






                                                    <div className="col-lg-12 mb-4">
                                                        <table className="table wage-data-tb" >
                                                            <thead className="thead-light">
                                                                <tr style={{ border: "1px" }}>
                                                                    <th scope="col">SOURCE</th>
                                                                    <th scope="col">Type</th>
                                                                    <th scope="col">LEVEL-1</th>
                                                                    <th scope="col">LEVEL-2</th>
                                                                    <th scope="col">LEVEL-3</th>
                                                                    <th scope="col">LEVEL-4</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>

                                                                    <th scope="row" >DOL Wage Data</th>
                                                                    <td id="">Yearly</td>
                                                                    <td id="dol_level1">{dolWageLevel1}</td>
                                                                    <td id="dol_level2">{dolWageLevel2}</td>
                                                                    <td id="dol_level3">{dolWageLevel3}</td>
                                                                    <td id="dol_level4">{dolWageLevel4}</td>

                                                                </tr>

                                                                <tr>
                                                                     <th scope="row" > </th>
                                                                    <td id="">Hourly</td>
                                                                    <td id="dol_level1_hourly">{dolWageHourlyLevel1}</td>
                                                                    <td id="dol_level2_hourly">{dolWageHourlyLevel2}</td>
                                                                    <td id="dol_level3_hourly">{dolWageHourlyLevel3}</td>
                                                                    <td id="dol_level4_hourly">{dolWageHourlyLevel4}</td>

                                                                </tr>

                                                                <tr>
                                                                    <th scope="row" >Local Survey Data</th>

                                                                    <td id="">Yearly</td>
                                                                    <td id="com_level1">{surveyWageLevel1}</td>
                                                                    <td id="com_level2">{surveyWageLevel2}</td>
                                                                    <td id="com_level3">{surveyWageLevel3}</td>
                                                                    <td id="com_level4">{surveyWageLevel4}</td>

                                                                </tr>


                                                                <tr>
                                                                <th scope="row" > </th>
                                                                    <td id="">Hourly</td>
                                                                    <td id="com_level1_hourly">{surveyWageHourlyLevel1}</td>
                                                                    <td id="com_level2_hourly">{surveyWageHourlyLevel2}</td>
                                                                    <td id="com_level3_hourly">{surveyWageHourlyLevel3}</td>
                                                                    <td id="com_level4_hourly">{surveyWageHourlyLevel4}</td>

                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>






                                                    <div id="successMessage" className="alert">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center">
                                                                <img src="/images/success-alert.png" alt="" />
                                                                <strong className="mx-2">Success!</strong> Details updated successfully.
                                                            </div>
                                                            <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                                                        </div>
                                                    </div>



                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </section>
               
            </main>

          
        </div>

      </form>

    </>
  )
}
export { WageData }